import publisherAPIInstance from "./publisherApiInstance";

const publisherAPIs = {
  emailPublish: ({ payload }) => publisherAPIInstance.post(`/api/v1/email.publish`, payload),
  sendErrorReport: ({ payload }) => publisherAPIInstance.post(`/api/v1/error_report`, payload),
  listPublishes: ({ payload, signal }) => publisherAPIInstance.post(`/api/v1/publishes.list`, payload, { signal }),
  getPublishFiles: ({ payload }) => publisherAPIInstance.post(`/api/v1/publish.files.get`, payload),
  brightCovePublish: ({ payload }) => publisherAPIInstance.post(`/api/v1/brightcove.publish`, payload),
  createBrightCoveCredentials: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/brightcove.create-credentials`, payload),
  createSocialProfile: ({ payload }) => publisherAPIInstance.post(`/api/v1/social_media.create_profile`, payload),
  getSocialProfiles: ({ payload }) => publisherAPIInstance.post(`/api/v1/social_media.get_profile`, payload),
  updateSocialProfile: ({ payload }) => publisherAPIInstance.post(`/api/v1/social_media.update_profile`, payload),
  deleteSocialProfile: ({ payload }) => publisherAPIInstance.post(`/api/v1/social_media.delete_profile`, payload),
  generateProfileJwt: ({ payload }) => publisherAPIInstance.post(`/api/v1/social_media.generate_profile_jwt`, payload),
  cloudPublishV2: ({ payload }) => publisherAPIInstance.post(`/api/v2/cloud.publish`, payload),
  getSocialMediaProviderProfiles: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/social_media/provider.get-profiles`, payload),
  emercePublish: ({ payload }) => publisherAPIInstance.post(`/api/v1/integration/emerce.publish`, payload),
  createEmerceCredentials: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/emerce.create-credentials`, payload),
  getActiveEmerceCredentials: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/emerce.get-credentials`, payload),
  socialMediaBulkPublish: ({ payload }) => publisherAPIInstance.post(`/api/v1/social_media.bulk_publish`, payload),
  retrySocialMediaBulkPublish: ({ payload }) => publisherAPIInstance.post(`/api/v1/social_media.retry_post`, payload),
  getYouTubePlaylists: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/social_media.get_youtube_playlists`, payload),
  getCustomProfileAuthUrl: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/social_media.custom.get_auth_url`, payload),
  completeSocialMediaAuth: ({ payload }) => publisherAPIInstance.post(`/api/v1/social_media.auth`, payload),
  disconnectCustomSocialMediaPlatform: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/social_media.custom.disconnect_platform`, payload),
  createStorifyMeCredentials: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/storifyme.create-credentials`, payload),
  getActiveStorifyMeCredentials: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/storifyme.get-credentials`, payload),
  disconnectStorifyMeCredentials: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/storifyme.disconnect`, payload),

  getStorifyMeStoriesList: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/storifyme.stories.fetch`, payload),
  publishMediaToStorifyMe: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/storifyme.add-media`, payload),
  addStoryToStorifyMe: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/storifyme.add-to-story`, payload),
  createStoryToStorifyMe: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/storifyme.create-story`, payload),
  getStorifyMeTemplatesList: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/storifyme.templates.fetch`, payload),
  getStorifyMeFoldersList: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/storifyme.folders.fetch`, payload),
  validateStorifyMeTemplate: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/storifyme.template.validate`, payload),

  // Slack Integration API's
  getSlackWorkspaceList: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/slack.workspace.list`, payload),
  initiateSlackAuth: ({ payload }) => publisherAPIInstance.post(`/api/v1/integration/slack.auth.initiate`, payload),
  handleSlackCallback: ({ payload }) => publisherAPIInstance.post(`/api/v1/integration/slack.auth.callback`, payload),
  disconnectSlackIntegration: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/slack.auth.disconnect`, payload),
  getSlackChannelsList: ({ payload }) => publisherAPIInstance.post(`/api/v1/integration/slack.channel.list`, payload),
  getSlackUsersList: ({ payload }) => publisherAPIInstance.post(`/api/v1/integration/slack.user.list`, payload),
  updateSelectedSlackChannel: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/slack.channel.select`, payload),
  slackPublish: ({ payload }) => publisherAPIInstance.post(`/api/v1/integration/slack.publish.notifier`, payload),

  // Dropbox Integration API's
  getDropboxAccountsList: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/dropbox.credential.list`, payload),
  initiateDropboxAuth: ({ payload }) => publisherAPIInstance.post(`/api/v1/integration/dropbox.auth.initiate`, payload),
  handleDropboxCallback: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/dropbox.auth.callback`, payload),
  disconnectDropboxIntegration: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/dropbox.auth.disconnect`, payload),
  getDropboxTeamFoldersList: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/dropbox.team.folder.list`, payload),
  updateDropboxTeamFolderSelect: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/dropbox.team.folder.select`, payload),
  dropboxPublish: ({ payload }) => publisherAPIInstance.post(`/api/v1/integration/dropbox.publish`, payload),
  distinctListPublishes: ({ payload, signal }) =>
    publisherAPIInstance.post(`/api/v1/publishes.distinct_list`, payload, { signal }),

  // DailyMotion Integration API's
  initiateDailyMotionAuth: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/dailymotion.auth.initiate`, payload),
  handleDailyMotionCallback: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/dailymotion.auth.callback`, payload),
  disconnectDailyMotionIntegration: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/dailymotion.auth.disconnect`, payload),
  getDailyMotionProfiles: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/dailymotion.credential.get`, payload),
  updateDailyMotionProfileSelect: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/dailymotion.profile.select`, payload),
  updateDailyMotionProfileDefault: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/dailymotion.profile.default`, payload),
  getDailyMotionCategories: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/dailymotion.categories.list`, payload),
  getDailyMotionLanguages: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/dailymotion.languages.list`, payload),
  getDailyMotionPlaylists: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/dailymotion.playlist.list`, payload),
  dailyMotionPublish: ({ payload }) => publisherAPIInstance.post(`/api/v1/integration/dailymotion.publish`, payload),

  // Google Drive Integration API's
  getGoogleDriveAccountsList: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/google-drive.credential.list`, payload),
  createGoogleDriveCredentials: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/google-drive.credential.create`, payload),
  disconnectGoogleDriveIntegration: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/google-drive.auth.disconnect`, payload),
  getGoogleDriveFoldersList: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/google-drive.folder.list`, payload),
  updateGoogleDriveDefaultFolder: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/google-drive.folder.default`, payload),
  getGoogleDrivePickerUrl: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/google-drive.picker.url`, payload),
  selectGoogleDriveFolders: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/google-drive.folder.select`, payload),
  googleDrivePublish: ({ payload }) => publisherAPIInstance.post(`/api/v1/integration/google-drive.publish`, payload),

  // Frame.io Integration API's
  getFrameIOCredentialsList: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/frameio.credentials.list`, payload),
  initiateFrameIOAuth: ({ payload }) => publisherAPIInstance.post(`/api/v1/integration/frameio.auth.initiate`, payload),
  handleFrameIOCallback: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/frameio.auth.callback`, payload),
  disconnectFrameIOIntegration: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/frameio.auth.disconnect`, payload),
  getFrameIOAccountDetails: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/frameio.account.details`, payload),
  getFrameIOAccounts: ({ payload }) => publisherAPIInstance.post(`/api/v1/integration/frameio.accounts.list`, payload),
  getFrameIOMe: ({ payload }) => publisherAPIInstance.post(`/api/v1/integration/frameio.me`, payload),
  getFrameIOTeams: ({ payload }) => publisherAPIInstance.post(`/api/v1/integration/frameio.teams.list`, payload),
  getFrameIOProjects: ({ payload }) => publisherAPIInstance.post(`/api/v1/integration/frameio.projects.list`, payload),

  getFrameIOAssets: ({ payload }) => publisherAPIInstance.post(`/api/v1/integration/frameio.assets.list`, payload),
  getFrameIOAssetTree: ({ payload }) => publisherAPIInstance.post(`/api/v1/integration/frameio.asset.getTree`, payload),
  frameIOPublish: ({ payload }) => publisherAPIInstance.post(`/api/v1/integration/frameio.publish`, payload),
  frameIOBulkPublish: ({ payload }) => publisherAPIInstance.post(`/api/v1/integration/frameio.bulkPublish`, payload),

  // Shade Integration API's
  getShadeAccountsList: ({ payload }) => publisherAPIInstance.post(`/api/v1/integration/shade.accounts.list`, payload),
  connectShadeAccount: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/shade.accounts.connect`, payload),
  disconnectShadeAccount: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/shade.accounts.disconnect`, payload),
  getShadeWorkspacesList: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/shade.workspaces.list`, payload),
  getShadeDrivesList: ({ payload }) => publisherAPIInstance.post(`/api/v1/integration/shade.drives.list`, payload),
  shadePublish: ({ payload }) => publisherAPIInstance.post(`/api/v1/integration/shade.publish`, payload),
};

export default publisherAPIs;
